import { observer } from 'mobx-react'
import React from 'react'
import ReactDOM from 'react-dom'
import { ReactSVG } from 'react-svg'

@observer
class ElementLayer extends React.Component {

  componentDidMount() {
    this.renderSvg()
  }

  componentDidUpdate() {
    this.renderSvg()
  }

  renderSvg = () => {
    const { stretchScale, xCrop, yCrop } = this.props
    const xCropValue = !isNaN(xCrop) ? xCrop : 0
    const yCropValue = !isNaN(yCrop) ? yCrop : 0
    ReactDOM.render
    (<ReactSVG
      className="element-layer__element-image"
      style={{
        width: this.props.displayWidth + 'px',
        height: this.props.displayHeight + 'px',
        transform: `translate(${-xCropValue}px, ${-yCropValue}px)`
      }}
      src={this.props.dataSource}
      wrapper="div"
      beforeInjection={(svg) => {
        svg.classList.add('svg-layer')
        svg.setAttribute('fill', this.props.fillHex)
        svg.setAttribute('style', `transform: scale3d(${stretchScale.x}, ${stretchScale.y}, 1)`)
        svg.setAttribute('preserveAspectRatio', "none")
        svg.setAttribute('width', "100%")
        svg.setAttribute('height', "100%")
      }}
    />,
    document.getElementById(`element-container-${this.props.id}`))
  }

  render(){
    const { id } = this.props
    return (
      <div
        className='element-layer'
        id={`element-container-${id}`}
      >
      </div>
    )
  }
}

export default ElementLayer